var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ContactStoreForm',{attrs:{"watchRef":this.item.product.manufacturer_sku},on:{"close":function () {_vm.$emit('close')}}},[_c('ProductMiniPreview',{attrs:{"item":this.item,"picture":this.picture}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }